export const TranslationAIActionTypes = {
  API_RESPONSE_SUCCESS: '@@translation-ai/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@translation-ai/API_RESPONSE_ERROR',

  ADD_TRANSLATION_AI: '@@translation-ai/ADD_TRANSLATION_AI',

  RESET: '@@translation-ai/RESET'
}
